import React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { CheckoutMessage } from '@/scopes/checkout/components/CheckoutMessage'
import { useCheckoutSid } from '@/scopes/checkout/domain/hooks'
import { ComponentsTypeApi } from '@/scopes/checkout/infrastructure/api/types'
import { CouponCodeForm } from '../components/CouponCode/CouponCodeForm'
import { CheckoutPriceOverview } from '../components/PriceOverview/CheckoutPriceOverview'
import styles from './Pages.module.css'

export function CheckoutItems() {
  const sid = useCheckoutSid()
  const items = useCMSPageField('Checkout.items')?.items ?? []

  if (!sid || !items) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      {items.map((item, index) => {
        const { type, componentId } = item
        switch (type) {
          case ComponentsTypeApi.ConditionalMessages:
            return <CheckoutMessage key={`${type}-${index}`} componentId={componentId} />
          case ComponentsTypeApi.CouponCode:
            return <CouponCodeForm key={`${type}-${index}`} />
          case ComponentsTypeApi.PriceOverview:
            return (
              <CheckoutPriceOverview key={`${type}-${index}`} glyph="money" type={ComponentsTypeApi.PriceOverview} />
            )
          case ComponentsTypeApi.PriceOverviewPerPerson:
            return (
              <CheckoutPriceOverview
                key={`${type}-${index}`}
                glyph="participantsBadge"
                type={ComponentsTypeApi.PriceOverviewPerPerson}
              />
            )
          default:
            if (window.newrelic) {
              const error = new Error(`[CheckoutSteps] No service ${type} found`)
              window.newrelic.noticeError(error)
            }
            return null
        }
      })}
    </div>
  )
}
